import { defineComponent as _defineComponent } from 'vue';
import Draggable from "./Draggable.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DraggablePan',
    props: {
        rootOffset: {
            type: Object,
            required: true,
        },
        scale: {
            type: Number,
            required: false,
            default: 1,
        },
        preventDefault: {
            type: Boolean,
            default: true,
        },
        stopPropagation: {
            type: Boolean,
            default: true,
        },
        dragData: {
            type: Object,
            required: false,
            default: null,
        },
    },
    emits: ["pan-by", "move", "mouseup"],
    setup(__props, { emit }) {
        const props = __props;
        let isPanning = false;
        const panBy = { x: 0, y: 0 };
        let movePosition = {
            x: 0,
            y: 0,
            unscaled: {
                x: 0,
                y: 0,
                width: 0,
                height: 0,
            },
        };
        let previousTimestamp;
        function pan(timestamp) {
            if (isPanning) {
                if (!previousTimestamp) {
                    previousTimestamp = timestamp;
                }
                const deltaTime = (timestamp - previousTimestamp) / 1000;
                const scaledPan = { x: panBy.x * deltaTime, y: panBy.y * deltaTime };
                emit("pan-by", scaledPan);
                // we need to move in the opposite direction of the pan
                movePosition.x -= scaledPan.x;
                movePosition.y -= scaledPan.y;
                emit("move", movePosition);
                previousTimestamp = timestamp;
                requestAnimationFrame(pan);
            }
            else {
                previousTimestamp = undefined;
            }
        }
        const panSpeedFactor = 6;
        function onMove(position, event) {
            let doPan = false;
            panBy.x = 0;
            panBy.y = 0;
            const deltaSpeed = (delta) => {
                const scaledDelta = Math.abs((delta * panSpeedFactor) / props.scale);
                const clampedDelta = Math.min(scaledDelta, 1200 / props.scale);
                return clampedDelta;
            };
            const unscaled = position.unscaled;
            const deltaLeft = unscaled.x - props.rootOffset.left;
            const deltaRight = props.rootOffset.right - unscaled.x - unscaled.width * props.scale;
            const deltaTop = unscaled.y - props.rootOffset.top;
            const deltaBottom = props.rootOffset.bottom - unscaled.y - unscaled.height * props.scale;
            if (deltaLeft < 0) {
                panBy.x = deltaSpeed(deltaLeft);
                doPan = true;
            }
            if (deltaTop < 0) {
                panBy.y = deltaSpeed(deltaTop);
                doPan = true;
            }
            if (deltaRight < 0) {
                panBy.x = -deltaSpeed(deltaRight);
                doPan = true;
            }
            if (deltaBottom < 0) {
                panBy.y = -deltaSpeed(deltaBottom);
                doPan = true;
            }
            movePosition = Object.assign({}, position);
            if (!doPan) {
                emit("move", position, event);
                isPanning = false;
            }
            if (doPan && !isPanning) {
                isPanning = true;
                requestAnimationFrame(pan);
            }
        }
        function onMouseUp(e) {
            isPanning = false;
            emit("mouseup", e);
        }
        return { __sfc: true, props, emit, isPanning, panBy, movePosition, previousTimestamp, pan, panSpeedFactor, onMove, onMouseUp, Draggable };
    }
});
